import { entityRegexStrategy } from '../commons';
export var mentionStrategy = entityRegexStrategy('USER_MENTION', /(^|\s)@(\w+\s?){0,2}/g);